import { useI18N } from "@sundae/react-hooks";
import { FC, Suspense, lazy, useMemo } from "react";
import { ADA_METADATA } from "../../../constants/cardano.constants";
import { useCurrentTasteTestContribution } from "../../../hooks/taste-test/useCurrentTasteTestContribution";
import { useTasteTestOrderAmountsI18n } from "../../../hooks/taste-test/useTasteTestOrderAmountsI18n";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import { numberI18n } from "../../../utils/number-format";
import { bigintToString } from "../../../utils/string-format";
import LoadingComponent from "../../LoadingComponent";
const LazyOrderSuccess = lazy(
  () => import(/* webpackChunkName: "OrderSuccess" */ "../../OrderComponents/OrderSuccess")
);

const TasteTestOrderSuccessView: FC = () => {
  const { currentLocale, t } = useI18N("taste-test");
  const {
    handlers: { resetTasteTestState },
    state: { actionType, persistedContributionsHistory },
  } = useTasteTestContext();
  const { token } = useTasteTestOrderAmountsI18n();
  const currentContribution = useCurrentTasteTestContribution();
  const persistedContribution = persistedContributionsHistory?.[0];
  const memoizedAmountOnSuccess = useMemo(() => {
    // TODO: use actual value from state
    if (actionType === "claim") {
      return numberI18n(
        10234122,
        { minimumFractionDigits: 0, maximumFractionDigits: 6 },
        currentLocale
      );
    }

    if (persistedContributionsHistory) {
      return numberI18n(
        Number(
          bigintToString(
            BigInt(persistedContribution?.details?.amount ?? "0"),
            ADA_METADATA.decimals
          )
        ),
        { minimumFractionDigits: 0, maximumFractionDigits: ADA_METADATA.decimals },
        currentLocale
      );
    }
  }, [actionType, currentLocale, persistedContributionsHistory, persistedContribution]);

  return (
    <Suspense fallback={<LoadingComponent />}>
      <LazyOrderSuccess
        className="max-w-[90%]"
        message={t(
          `transaction.tasteTest.success.${persistedContribution?.type ?? "claim" ?? "deposit"}`,
          {
            amount: memoizedAmountOnSuccess,
            token,
            ns: "transactions",
            total: numberI18n(
              currentContribution?.value?.toNumber(),
              { minimumFractionDigits: 0, maximumFractionDigits: ADA_METADATA.decimals },
              currentLocale
            ),
          }
        )}
        onCancel={resetTasteTestState}
        onSuccess={resetTasteTestState}
        onSuccessButtonText={t("close", { ns: "common" })}
      />
    </Suspense>
  );
};

export default TasteTestOrderSuccessView;
